import React, { Component } from "react";
import axios from 'axios';
import { Button } from "@progress/kendo-react-buttons";
import Style from './Style';


class StyleSetting extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            company: this.props.company,
            chartColors: this.props.chartColors,
            updates: [],
            changed: false,
            cornerLogo: null
        }

        this.clearState = this.clearState.bind(this);
        this.createCell = this.createCell.bind(this);
        this.uploadLogo = this.uploadLogo.bind(this);
    }

    componentDidMount() {

    }

    createCell(cell) {
        if (cell.rowType === 'data') {
            return (
                <div>
                    <Button className='docButton' onClick={(event) => this.addHouseholdMapping(event, cell)}>Add Account Mapping</Button>
                </div>
            );
        }
        else {
            return (
                <></>
            );
        }
    }

    validityTest() {
        var errorString = ''
        for (let style of this.state.updates) {
            if (style.dataType === 'email') {
                if (!emailRegex.test(style.value) && style.value/*allows empty email*/) {
                    errorString = errorString.concat(style.description + ' - Email Address is not in correct format\n\n')
                }
            }
            if (style.name === 'contactLabel') {
                if (style.value.length > 18) {
                    errorString = errorString.concat(style.description + ` - Restricted to 18 characters. Current length is ${style.value.length}.\n\n`)
                }
            }
        }

        if (errorString) {
            return 'Please correct issues with the following fields:\n\n' + errorString
        }
        else {
            return false
        }
    }


    _handleChange = e => {
        var newUpdates = this.state.updates

        var value = null
        var availableValues = null

        if (e.target.props.dataType === 'sortable'){
            value = []
            availableValues = []
            
            e.newState.forEach(element => {
                value.push(element.id)
                availableValues.push(element.text)
            })
            value = value.join('|')//create pipe delmited string
            availableValues = availableValues.join('|')
        }

        var index = (newUpdates.findIndex(x => { return x.name === e.target.props.name; }))

        if (index !== -1) {
            newUpdates[index].name = e.target.name || e.target.props.name
            newUpdates[index].description = e.target.props.description
            newUpdates[index].dataType = e.target.props.dataType
            newUpdates[index].value = value || e.target.value
            newUpdates[index].availableValues = availableValues
        }
        else {
            newUpdates.push({ 
                name: e.target.name || e.target.props.name, 
                description: e.target.props.description, 
                value: value || e.target.value, 
                dataType: e.target.props.dataType,
                availableValues: availableValues
            })
        }

        this.setState({
            updates: newUpdates, changed: true
        })

        this.props.changed()
    }

    _handleColorChange = (color, style) => {

        var newUpdates = this.state.updates

        var index = (newUpdates.findIndex(x => { return x.name === style.name; }))

        var newColor = 'rgb(' + color.rgb.r + ',' + color.rgb.g + ',' + color.rgb.b + ',' + color.rgb.a + ')'

        if (index !== -1) {
            newUpdates[index].name = style.name
            newUpdates[index].description = style.description
            newUpdates[index].value = newColor
            newUpdates[index].dataType = style.dataType
        }
        else {
            newUpdates.push({ name: style.name, description: style.description, value: newColor, dataType: style.dataType })
        }

        this.setState({
            updates: newUpdates, changed: true
        })

        this.props.changed()



    }


    _handleChartColorChange = (colorList, style) => {

        var newUpdates = this.state.updates

        var index = (newUpdates.findIndex(x => { return x.name === style.name; }))

        var colorListString = ''
        colorList.forEach(c => {
            colorListString = colorListString.concat('rgb(' + c.color.r + ',' + c.color.g + ',' + c.color.b + ',' + c.color.a + ')<' + (c.mapping || '') + '|')
        })
        colorListString = colorListString.slice(0, -1);//trims last character

        if (index !== -1) {
            newUpdates[index].name = style.name
            newUpdates[index].description = style.description
            newUpdates[index].value = colorListString
            newUpdates[index].dataType = style.dataType
        }
        else {
            newUpdates.push({ name: style.name, description: style.description, value: colorListString, dataType: style.dataType })
        }

        this.setState({
            updates: newUpdates, changed: true
        })
        
        this.props.changed()



    }

    _handleLogoChange = e => {
        this.setState({ cornerLogo: e.target.files[0], cornerPreview: URL.createObjectURL(e.target.files[0]) })

        var newUpdates = this.state.updates

        var index = (newUpdates.findIndex(x => { return x.name === 'cornerLogo'; }))

        if (index !== -1) {
            newUpdates[index].name = 'cornerLogo'
            newUpdates[index].description = ''
            newUpdates[index].dataType = 'cornerLogo'
            newUpdates[index].value = this.props.company + e.target.files[0].name.substring(e.target.files[0].name.indexOf('.'))
        }
        else {
            newUpdates.push({ 
                name: 'cornerLogo', 
                description: '', 
                value: this.props.company + e.target.files[0].name.substring(e.target.files[0].name.indexOf('.')), 
                dataType: 'cornerLogo',
            })
        }

        this.setState({
            updates: newUpdates, changed: true
        })

        this.props.changed()
    }

    uploadLogo() {
        var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
        const formData = new FormData();
        formData.append('company', 'logos');
        formData.append('logoCompany', this.props.company);
        formData.append('type', 'logo');
        formData.append('prevLogo', this.props.compSettings.cornerLogo);
        formData.append(this.props.company + this.state.cornerLogo.name.substring(this.state.cornerLogo.name.indexOf('.')), this.state.cornerLogo);
    
    
        axios.post('api/logo?company='+this.props.company, formData, { headers }).then(response => {
          if (response.data.code === 200) {
            this.props.onCompSettingsChange('cornerLogo', response.data.newlogo);

            // this.props.setStyle(copyStyle);
            // this.props.onCompSettingsChange('cornerLogo', response.data.newlogo);
            // this.props.refresh('style');
            // alert("Style Settings have been updated.");
          }
        }).catch(err => console.log(err));
      }

    saveChanges = e => {

        var validityMessage = this.validityTest()

        if (validityMessage) {
            alert(validityMessage)
        }
        else {
            var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

            this.state.updates.forEach(u => {
                //escape single quote
                if (u.dataType === 'text'){
                    u.value = u.value.replace(new RegExp("'", "g"), "''")
                }
                //set blanks to 0.0
                if (u.dataType === 'decimal' & u.value === ''){
                    u.value = '0.0'
                }
                if (u.dataType === 'multiselect'){
                    var newValue = ''
                    u.value.forEach(v => {
                        newValue = newValue.concat(v + '|')
                    })
                    u.value = newValue.slice(0, -1);//trims last character which is a pipe
                }
            })

            var payload = {
                company: this.props.company,
                updates: this.state.updates,
            }
            console.log(payload)
            axios.post("api/saveStyleSettings", payload, { headers }).then(response => {
                if (response.data.code === 200) {
                    if (this.state.cornerLogo !== null && this.state.cornerLogo !== undefined){
                        this.uploadLogo()
                    }
                    alert('Style Settings Saved Successfully');
                    //callback();
                    this.props.saved()
                    this.setState({ changed: false })
                }
                else {
                    alert(response.data.error);
                    //callback("ERROR");
                }
            }).catch(err => {
                alert("An error has occured");
                console.log(err);
                //callback("ERROR");
            });
        }
    }


    clearState() {
        this.setState({
            updates: [],
            cornerLogo: null
        });
    }

    render() {
        return (
            <div>
                <div className="applyChangesContainer">
                    <Button
                        onClick={this.saveChanges}
                        disabled={!this.state.changed}
                    >
                        Apply Changes
                    </Button>
                </div>
                <table className="styleTable">
                    <tbody>
                        {this.props.contents.map((style, i) => {
                            if (!this.props.enableMFA && (style.name === 'userTurnOnMFA' || style.name === 'userChangeMFAPhoneNumber')){
                                return <></>
                            }
                            else {
                            return (
                                <>
                                    {style.subgroup &&
                                        <div className="styleTableSubgroup">{style.subgroup}:</div>
                                    }
                                    <Style
                                        style={style}
                                        key={i}
                                        _handleChange={this._handleChange}
                                        _handleColorChange={this._handleColorChange}
                                        _handleChartColorChange={this._handleChartColorChange}
                                        _handleLogoChange={this._handleLogoChange}
                                        compSettings={this.props.compSettings}
                                        company={this.props.company}
                                        chartColors={this.state.chartColors}
                                    />
                                </>
                            )}
                        })}
                    </tbody>
                </table>
                <br />
                <br />
            </div>
        );
    }

}

const emailRegex= RegExp( process.env.REACT_APP_EMAIL_REGEX );


export default StyleSetting;